import React, { FC } from 'react';
import { useInspirationalTemplates } from '../../hooks/useInspirationalTemplates';
import { InspirationalTemplatesGridItem } from './InspirationalTemplatesGridItem/InspirationalTemplatesGridItem';

import s from './InspirationalTemplatesGrid.scss';

export const InspirationalTemplatesGrid: FC = () => {
  const templates = useInspirationalTemplates();

  return (
    <div className={s.grid}>
      {templates?.map((template, index) => (
        <InspirationalTemplatesGridItem
          key={template.templateId}
          template={template}
          index={index}
        />
      ))}
    </div>
  );
};
